import Button from "@app/sharedComponents/Button/Button";
import { ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import { X } from '@sharedComponents/Icons';

const UpdatedOutstanding = ({closeBottomSheet,currentOutStanding,totalPrincipalOutStanding,withdrawalAmount}) =>{
    return(
        <ThemedView p="lg">
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center" mb="2xl">
                <ThemedText variant="h5s" color="text-primary" >Updated principal outstanding</ThemedText>
                
            </ThemedView>
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="lg"
                >
                <ThemedText variant="b3r" color='text-primary'>
                    Current outstanding
                </ThemedText>
                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(currentOutStanding)}
                </ThemedText>
            </ThemedView>
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                >
                <ThemedText variant="b3r" color='text-primary'>
                    Withdrawal amount
                </ThemedText>
                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(withdrawalAmount)}
                </ThemedText>
            </ThemedView>
            <ThemedView height={1} backgroundColor="border-secondary" width={"100%"} my="lg" />
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="2xl"
                >
                <ThemedText variant="b3s" color='text-primary'>
                   Total outstanding
                </ThemedText>
                <ThemedText variant="b3s" color='text-primary'>
                    ₹{formatIndianCurrency(totalPrincipalOutStanding)}
                </ThemedText>
            </ThemedView>
            <Button label="Ok, got it!" type="SOLID" handlePress={closeBottomSheet}/>
        </ThemedView>
    )
}

export default UpdatedOutstanding;